export default __webpack_public_path__ + "957f749a235a6f9239134228e39b9f42.pdf";